SupportUtilsHelper = require('../helpers/utils')
Backbone = require 'backbone'

class SupportLiveChatModel extends Backbone.Model

  initialize:->
    @setDefaults()

  setDefaults: ->
    attrs =
      userEmail: window.currentUser?.email
      userName:  SupportUtilsHelper.getCurrentUserFullName()
      isLogged:  window.currentUser?.email?
      liveChat:  window.liveChatInfo
      initialQuestion: ""
    @set attrs, slient: true

  escapePunctuationsAndSanitize: (text) ->
    text = text.replace(/\\/g,"\\\\")
    text = text.replace(/\"/g, '\\"')
    text = text.replace(/(<([^>]+)>)/ig,"")

  setIntialQuestion: (params)->
    initialQuestion = []
    if params?.issue?
      issue = @escapePunctuationsAndSanitize(params.issue)
      initialQuestion.push("#{I18n.translate('js.modules.support.issue')} #{issue}")
    if Groupon.Support.currentOrder
      currentOrder = Groupon.Support.currentOrder
      if isUS()
        initialQuestion.push("#{I18n.translate('js.modules.support.order_no')}: #{currentOrder.id}")
      if currentOrder.deal?
        initialQuestion.push("#{I18n.translate('js.modules.support.deal_concerned')} #{currentOrder.deal.id}")

      if isIntl() && currentOrder.groupons?[0]?.redemptionCode?
        initialQuestion.push("#{I18n.translate('js.modules.support.security_code')}: #{currentOrder.groupons[0].redemptionCode}")

    if initialQuestion.length > 0
      initialQuestion.push("\\n")
      @set initialQuestion: initialQuestion.join("\\n")
    else
      @set initialQuestion: ""

  setLiveChatInfo:(liveChatType) ->
    liveChatType = @getLiveChatType(liveChatType)
    @setLiveChatType(liveChatType)
    @setLiveChatCharacter(liveChatType)

  setLiveChatType:(liveChatType)->
    switch liveChatType
      when 'normal_live_chat' then @set 'liveChat', window.liveChatInfo
      when 'optimized_live_chat' then @set 'liveChat', window.liveChatInfo?.optimizedBoldChat
      when 'getaways_live_chat' then @set 'liveChat', window.liveChatInfo?.getaways
      when 'flexible_live_chat' then @set 'liveChat', window.liveChatInfo?.flexibleBoldChat
      when 'live_chat_link' then @set 'liveChat', window.liveChatInfo?.linkBoldChat
      when 'optimized_getaways_live_chat' then @set 'liveChat', window.liveChatInfo?.optimizedBoldChat?.getaways
      when 'flexible_getaways_live_chat' then @set 'liveChat', window.liveChatInfo?.flexibleBoldChat?.getaways
      when 'flexible_v2_live_chat' then @set 'liveChat', window.liveChatInfo?.flexibleBoldChat?.v2
      when 'live_chat_getaways_link' then @set 'liveChat', window.liveChatInfo?.linkBoldChat?.getaways

  setLiveChatCharacter:(liveChatType)->
    if liveChatType in [ "live_chat_link", "live_chat_getaways_link" ]
      @set("is_chat_link", true)
    else
      @set("is_chat_link", false)

  getLiveChatType: (liveChatType)->
    if liveChatType? then return liveChatType
    if @shouldShowFlexibleLiveChat()
      @getFlexibleLiveChatType()
    else if @shouldShowOptimizedLiveChat()
      @getOptimizedLiveChatType()
    else
      @getDefaultLiveChatType()

  shouldShowOptimizedLiveChat: () ->
    window.shouldShowOptimizedChannel()

  shouldShowFlexibleLiveChat: () ->
    window.shouldShowFlexibleChannel()

  shouldShowGetawaysLiveChat: () ->
    isCurrentOrderGetawaysDeal() and isUS()

  getDefaultStepTwoLiveChatMode:  ->
    window.liveChatInfo?.mode?.step_two

  getDefaultStepThreeLiveChatMode:  ->
    window.liveChatInfo?.mode?.step_three

  getDefaultLiveChatType:  ->
    if @shouldShowGetawaysLiveChat()
      'getaways_live_chat'
    else
      'normal_live_chat'

  getOptimizedLiveChatType:  ->
    if @shouldShowGetawaysLiveChat()
      'optimized_getaways_live_chat'
    else
      'optimized_live_chat'

  getFlexibleLiveChatType:  ->
    if @shouldShowGetawaysLiveChat()
      'flexible_getaways_live_chat'
    else
      'flexible_live_chat'

  getFlexibleV2LiveChatType:  ->
    'flexible_v2_live_chat'

  getLinkLiveChatType:  ->
    if @shouldShowGetawaysLiveChat()
      'live_chat_getaways_link'
    else
      'live_chat_link'

  shouldShowStepTwoLiveChat: () ->
    liveChatmode = @getDefaultStepTwoLiveChatMode()
    liveChatmode? && isFloatingLiveChat(liveChatmode)

  isLiveChatEnabled: ->
    Groupon.Support.FeatureFlagModel.isShowLiveChatEnabled() && not(_.isEmpty window.liveChatInfo)

module.exports = SupportLiveChatModel
